import _ from 'lodash';
import { FC } from 'react';
import { Proportion, Image } from '@wix/design-system';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common';
import Slider from 'react-slick';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import { ImageSource } from '@common/types';
import { useTemplateBi } from '@components/Hooks/useTemplateBi';
import CustomArrowWrapper from '../CustomArrowWrapper';

import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import s from './MobileCarousel.module.scss';

const MobileCarousel: FC = () => {
  const {
    template: {
      media: { additionalImages },
    },
  } = useTemplateContext();
  const { logBiClick } = useTemplateBi({ is_mobile: true });

  const isInfinite =
    !_.isEmpty(additionalImages) && additionalImages?.length! > 1;

  const settings = {
    dots: false,
    infinite: isInfinite,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div style={{ display: 'block', overflow: 'hidden' }}>
      <Slider
        className={s.mobileHeroCarousel}
        nextArrow={
          <CustomArrowWrapper>
            <ChevronRight
              onClick={() =>
                logBiClick({ clickType: 'next picture - from Image' })
              }
              color="#ffffff"
            />
          </CustomArrowWrapper>
        }
        prevArrow={
          <CustomArrowWrapper>
            <ChevronLeft
              onClick={() =>
                logBiClick({ clickType: 'previous picture - from Image' })
              }
              color="#ffffff"
            />
          </CustomArrowWrapper>
        }
        {...settings}
      >
        {Array.isArray(additionalImages) &&
          additionalImages.map((slide, id) => (
            <CarouselImage key={id} {...slide} />
          ))}
      </Slider>
    </div>
  );
};

export default MobileCarousel;

const CarouselImage: FC<ImageSource> = ({ url, description }) => {
  return (
    <Proportion key={url} aspectRatio={8 / 5}>
      <Image
        dataHook={`slide-${url}`}
        fit="cover"
        borderRadius={0}
        transparent
        alt={description || 'template image'}
        src={url}
      />
    </Proportion>
  );
};
